var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 15C15.912 15 16.1472 15.4704 15.9 15.8L12.4 20.4667C12.2 20.7333 11.8 20.7333 11.6 20.4667L8.1 15.8C7.85279 15.4704 8.08798 15 8.5 15L15.5 15Z",
    fill: "#97A0AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 9C15.912 9 16.1472 8.52962 15.9 8.2L12.4 3.53333C12.2 3.26667 11.8 3.26667 11.6 3.53333L8.1 8.2C7.85279 8.52962 8.08798 9 8.5 9L15.5 9Z",
    fill: "#97A0AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.c8487760588917c4da18be03aa80ca47.svg";
export { ForwardRef as ReactComponent };